import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../preloader.json';

type LoadingScreenProps = {
  message?: string;
  className?: string;
  size?: number;
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Carregando...',
  className = 'min-h-screen bg-gray-50',
  size = 220,
}) => {
  return (
    <div className={`${className} flex items-center justify-center p-4`}>
      <div className="text-center">
        <div className="mx-auto" style={{ width: size, height: size }}>
          <Lottie animationData={animationData} loop autoplay />
        </div>
        {message ? <p className="text-gray-600 mt-2">{message}</p> : null}
      </div>
    </div>
  );
};

export default LoadingScreen;
